<template>
<div>
   <vs-row vs-type="flex">
      <ValidationObserver ref="addMultipleObserver">
        <vs-col vs-justify="flex-start" vs-lg="3" class="p-3">
          <ValidationProvider :name="$t('Decarbonization.EnergyTypeRatio.EnergySource')" rules="required" v-slot="{ errors }">
            <form-label>{{$t('Decarbonization.EnergyTypeRatio.EnergySource')}}</form-label>
            <v-select
              :options="energySources"
              label="name"
              :reduce="energy => energy.id"
              v-model="energySource"
              class="w-full"
              name="energySourceId"
            />
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('Decarbonization.EnergyTypeRatio.StartYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('Decarbonization.EnergyTypeRatio.StartYear')" 
              v-model="startYear"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('Decarbonization.EnergyTypeRatio.EndYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('Decarbonization.EnergyTypeRatio.EndYear')" 
              v-model="endYear"
              class="nowrap">          
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="1" class="p-3">
          <ValidationProvider :name="$t('Decarbonization.EnergyTypeRatio.Rate')" rules="required|decimal|between:0,100" v-slot="{ errors }">
            <validated-input :label="$t('Decarbonization.EnergyTypeRatio.Rate')" 
              v-model="rate"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col v-if="!readOnly" vs-type="flex" vs-justify="flex-start" vs-lg="3" class="align-items-center mt-8 pt-1" >
          <vs-button type="border" class="align-items-center" color="danger" @click="addMultipleRatios" >{{ $t('Decarbonization.EnergyTypeRatio.BatchAddTitle') }}</vs-button>
        </vs-col>
      </ValidationObserver>
    </vs-row>
    <vs-row class="yesscroll">
      <vs-table :data="yearlyRatios" class="noscroll">
        <template slot="thead" >
          <vs-th width="200px">{{ $t("Decarbonization.EnergyTypeRatio.EnergySource")}}</vs-th>
          <vs-th width="110px" style="min-width: 110px;" v-for="(year, index) in years" :key="index">
            <span>
              {{ year }}
            </span>
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="d in data" :key="d.energySource">
            <vs-td :data="d.energySource">
              <vs-row>
                <vs-col>
                  {{ getEnergySourceName(d.energySource) }}
                </vs-col>
              </vs-row>
            </vs-td>
            <vs-td :data="d.values[index].rate" align="center" v-for="(value, index) in d.values" :key="index">
              <ValidationProvider :name="$t('Decarbonization.EnergyTypeRatio.Rate')" immediate rules="required|decimal|min_value:0|max_value:100" v-slot="{ errors }">
                <vs-input :disabled="readOnly" v-model="d.values[index].rate" class="w-full" v-if="d.values[index].id!=null" v-on:change="onEditRate($event, d.values[index].id)" />
                <span v-if="d.values[index].id==null">N/A</span>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td width="200px">{{ $t("Decarbonization.EnergyTypeRatio.Total")}}</vs-td>
            <vs-td width="110px" v-for="(year, index) in years" :key="index">
              <span>
                <ValidationProvider :name="$t('Decarbonization.EnergyTypeRatio.Total')" immediate rules="min_value:100|max_value:100" v-slot="{ errors }">
                  <vs-input :disabled="true" v-model="yearlyTotal[index]" class="w-full yearly-total" />
                  <validation-message>{{ errors[0] }}</validation-message>
                </ValidationProvider>
              </span>
            </vs-td>
          </vs-tr>
        </template> 
      </vs-table>
    </vs-row>
</div>

</template>
<script>

import EnergySourcesEnum from "./../../../enums/EnergySources.js";
import vSelect from 'vue-select';

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    FormLabel,    
    vSelect,
    ValidatedInput,
    ValidationMessage
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    templateId : {
      type: Number
    },
    yearlyRatios: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      startYear: null,
      endYear: null,
      energySource: null,
      rate: 0,
      context: { componentParent: this },
      energySources: [
        { name: this.getEnergySourceName(EnergySourcesEnum.GridEnergy), id: EnergySourcesEnum.GridEnergy },
        { name: this.getEnergySourceName(EnergySourcesEnum.DieselPrimeMover), id: EnergySourcesEnum.DieselPrimeMover },
        { name: this.getEnergySourceName(EnergySourcesEnum.DieselEquipment), id: EnergySourcesEnum.DieselEquipment },
        { name: this.getEnergySourceName(EnergySourcesEnum.Gasoline), id: EnergySourcesEnum.Gasoline },
        { name: this.getEnergySourceName(EnergySourcesEnum.NaturalGas), id: EnergySourcesEnum.NaturalGas }
      ]
    };
  },
  created() {
    this.initValues();
  },

  computed: {
    years () {
      return this.$props.yearlyRatios.map(item => item.values.map(v => v.year))[0];
    },
    yearlyTotal () {
      return this.years.map(year => this.getTotal(year));
    }
  },

  methods: {
    initValues() {
      if (this.data) return;
      this.startYear = new Date().getFullYear();
      this.endYear = null;
      this.energySource = EnergySourcesEnum.GridEnergy;
      this.rate = 0;
    },
    addNewData() {
      this.$emit("onAddYearlyRatio");
    },
    addMultipleRatios() {
      this.$refs.addMultipleObserver.validate().then(result => {
        if (result) {
          this.$vs.loading();
          this.$cqrsPost('cashflow/decarbonization/energySupplyTemplates/addMultipleRatios', { 
            templateId: this.templateId,
            energySource: this.energySource,
            startYear: this.startYear,
            endYear: this.endYear,
            rate: this.rate
          }).then((response) => {
            this.$notifySaveSuccess();
            this.$emit("onRebindYearlyRatios", response.data.model);
          }).finally(() => {
            this.$vs.loading.close();
          });
        }
      });
    },
    getEnergySourceName(source) {
      return this.$t("Decarbonization.EnergySourcesEnum." + source);
    },
    getTotal (year) {
      let total = 0;
      for (let i = 0; i  < this.$props.yearlyRatios.length; i++) 
      {
        const item = this.$props.yearlyRatios[i].values.find(x => x.year === year);
        if (item) {
          total += Number(item.rate);
        }
      }
      return total;
    },
    onEditRate(event, yearlyRatioId) {
      const value = event.target.value;
      if (value === null || value === "") {
        return;
      }

      if (Number(value) === 0) {
        this.deleteRate(yearlyRatioId);
        return;
      }

      this.$cqrsPost('cashflow/decarbonization/energySupplyTemplates/EditYearlyRatio', { 
        id: yearlyRatioId,
        rate: value
      }).finally(() => {
        this.$vs.loading.close();
      });
    },

    deleteRate(yearlyRatioId) {
      this.$cqrsPost('cashflow/decarbonization/energySupplyTemplates/DeleteYearlyRatio', { 
        id: yearlyRatioId
      }).then(() => {
        const flattenedYearlyRatios = this.yearlyRatios.flatMap(x => x.values);
        const nowDeletedRatio = flattenedYearlyRatios.find(x => x.id === yearlyRatioId);
        nowDeletedRatio.id = null;
        nowDeletedRatio.rate = null;
      }).catch((response) => {
        console.log(response);
      });
      
    }
  }
};
</script>

<style lang="scss">
  .yearly-total input {
    border-style: none !important;
    background-color: white !important;
    color: black !important;
    font-weight: bolder;
    opacity: 1;
  }

  .nowrap {
    white-space: nowrap;
  }

  .noscroll {
    overflow: initial !important;
  }

  .yesscroll {
    overflow-x: auto;
  }

</style>